import router from './router'
import store from './store'
import NProgress from 'nprogress'
import {Message} from 'element-ui'
import '@/styles/nprogress.css'
import {getToken} from '@/utils/auth'
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({showSpinner: false})

const whiteList = ['/login', '/', '/about']

router.beforeEach(async (to, from, next) => {
  NProgress.start()

  document.title = getPageTitle(to.meta.title)

  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/login') {
      next({path: '/account'})
      NProgress.done()
    } else {
      const hasRoles = store.getters.roles && store.getters.roles.length > 0
      if (hasRoles) {
        next()
      } else {
        try {
          const roles = ["admin"]
          store.dispatch("sys/setRoles", roles);
          store.dispatch('sys/getAdmin')
          await store.dispatch('sys/getDictMap')
          await store.dispatch('sys/getCountryMap')
          await store.dispatch('sys/getOptions')
          const {data} = await store.dispatch("sys/getPermission", roles);
          await store.dispatch('permission/generateRoutes', data)
          next({...to, replace: true})
        } catch (error) {
          // remove token and go to login page to re-login
          Message.error(error || 'Has Error')
          //next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})
router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/admin/permission.js